import { render, staticRenderFns } from "./packageRecord.vue?vue&type=template&id=5614d177&scoped=true"
import script from "./packageRecord.vue?vue&type=script&lang=js"
export * from "./packageRecord.vue?vue&type=script&lang=js"
import style0 from "./packageRecord.vue?vue&type=style&index=0&id=5614d177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614d177",
  null
  
)

export default component.exports